import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapperForm from "../../components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { BannerManagementConfig } from "../../config/tableConfigs";
import BannerFormModal from "./components/BannerFormModal";
import DeleteModal from "../../components/DeleteModal";
import { useSession } from "hooks/useSession";

const BannerManagementPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const { userid } = useSession();

  const handleAddBanner = () => {
    setModalMode("add");
    setSelectedBanner(null);
    setModalShow(true);
  };
const formdata = new FormData();
  formdata.append("action", "GET");        // ✅ action field
  formdata.append("company", userid); 
  // ✅ GET uses query param ?company=  (matches request.GET.get("company"))
  const tableData = useTableDataWithPost(
    `https://pro.mokshiq.in/banner_management`,
    BannerManagementConfig,
    formdata,     // no POST body needed — it's a GET request
    refresh
  );

  const handleView = (banner) => {
    console.log("Viewing banner:", banner);
  };

  const handleEditBanner = (banner) => {
    setModalMode("edit");
    setSelectedBanner(banner);
    setModalShow(true);
  };

  const handleDelete = (banner) => {
    setSelectedBanner(banner);
    setTimeout(() => {
      const modalEl = document.getElementById("deletebanner1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      setRefresh((prev) => prev + 1);
    }
  };

  const handleFormSuccess = () => {
    setRefresh((prev) => prev + 1);
    setModalShow(false);
  };

  const handleDeleteSuccess = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={BannerManagementConfig}
        handleOnclick={handleAddBanner}
        buttonTitle="Add Banner"
      >
        <DataTable
          config={BannerManagementConfig}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditBanner}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      <BannerFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedBanner}   // has: { name, photo, type } from GET
        onSuccess={handleFormSuccess}
      />

     <DeleteModal
        deleteid={selectedBanner?.id}
        id="deletebanner1"
        title="Delete Banner"
        message="Are you sure you want to delete this banner?"
        apiUrl="https://pro.mokshiq.in/banner_management"
        deleteKey="banner_id"          // ✅ field name sent to API
        action="DELETE"                // ✅ action field
        onSuccess={handleDeleteSuccess}
    />
    </div>
  );
};

export default BannerManagementPage;